import React from "react";
import { STATUS_KEYS, STATUS_META } from "../utils/constants";

export default function ControlsBar({ filters, services, onChange }) {
  return (
    <section className="controls-bar">
      <div className="search-box">
        <svg viewBox="0 0 24 24" className="search-icon"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg>
        <input
          type="text"
          id="search-input"
          placeholder="Search by Job #, Customer, Contact, Phone or Service type..."
          value={filters.search}
          onChange={(e) => onChange({ search: e.target.value })}
        />
      </div>
      <div className="filters-group">
        <div className="filter-item">
          <label htmlFor="filter-status">Status:</label>
          <select id="filter-status" value={filters.status} onChange={(e) => onChange({ status: e.target.value })}>
            <option value="ALL">All Statuses</option>
            {STATUS_KEYS.map((key) => (
              <option key={key} value={key}>
                {STATUS_META[key].label}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-item">
          <label htmlFor="filter-service">Service:</label>
          <select id="filter-service" value={filters.service} onChange={(e) => onChange({ service: e.target.value })}>
            <option value="ALL">All Services</option>
            {services.map((service) => (
              <option key={service} value={service}>
                {service}
              </option>
            ))}
          </select>
        </div>
      </div>
    </section>
  );
}
